export const transitions = {
  fast: '100ms',
  normal: '300ms',
} as const;
